// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nv-3";
export var downloadButton = "_nv-4";
export var fileContainer = "_nv-9 _nv-7";
export var fileContainerBase = "_nv-7";
export var fileContainerFixedHeight = "_nv-8 _nv-7";
export var fileInfo = "_nv-5";
export var fileInfoWidthRestricted = "_nv-6";
export var fileType = "_nv-1";
export var fileTypeName = "_nv-2";
export var image = "_nv-0";
export var link = "_nv-b";
export var overflowEllipsis = "_nv-a";